export default __webpack_public_path__ + "static/404-4dffbb1b0316317f45bc6f49bc789ac8.svg";